var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"es-icon"},[_c('font-awesome-icon',{attrs:{"icon":[`${_vm.name ? 'fab' : 'far'}`, `${_vm.name || 'credit-card'}`]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }